import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

interface Faq1Props {
  uptitle?: string;
  title?: string;
  items?: FaqItem[];
  backgroundColor?: string;
}

const Faq1 = ({
  uptitle = "Person inmobiliaria",
  title = "Nuestro proceso",
  items = [
    {
      id: "faq-1",
      question: "1. Valoración del inmueble",
      answer:
        "En Person Inmobiliaria, valoramos tu propiedad con un análisis profesional y personalizado. Nuestro equipo de expertos evaluará su ubicación, características y mercado local para ofrecerte una valoración justa y precisa en 48 horas.",
    },
    {
      id: "faq-2",
      question: "2. Visuales y estrategias de marketing",
      answer:
        "Realizamos un estudio de fotografía, preparamos un Tour 3D y diseñamos una estrategia de marketing para conseguir un posicionamiento premium del inmueble.",
    },
    {
      id: "faq-3",
      question: "3. Publicación y difusión",
      answer:
        "Publicamos de forma destacada la vivienda en los principales portales inmobiliarios y nos ponemos en contacto con potenciales clientes interesados de nuestra base de datos.",
    },
    {
      id: "faq-4",
      question: "4. Visitas y filtración",
      answer:
        "Mostramos la propiedad a todos los potenciales compradores, ayudándolos y calificándolos durante todo el proceso.",
    },
    {
      id: "faq-5",
      question: "5. Asesoramiento legal",
      answer:
        "Ayudamos a ambas partes a navegar todos los aspectos legales de la operación usando nuestro conocimiento y experiencia en la industria.",
    }
  ],
  backgroundColor = "#FFFFFF",
}: Faq1Props) => {
  return (
    <section className="py-44 px-6" style={{ backgroundColor }}>
      <div className="mx-auto w-full max-w-3xl">
        {/* Title */}
        <div className="flex flex-col items-center gap-2 mb-4 md:mb-11">
          <p className="text-center text-muted-foreground">{uptitle}</p>
          <h2 className="text-center text-3xl lg:text-2xl">
            {title}
          </h2>
        </div>
        <Accordion type="single" collapsible>
          {items.map((item, index) => (
            <AccordionItem key={item.id ?? index} value={`item-${index}`}>
              <AccordionTrigger className="hover:no-underline cursor-pointer font-normal">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export { Faq1 };

